import { app } from '../../../../../../app';

app.service('EditProfileMainModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (profile) => {
        return $uibModal.open({
            component: 'editMainProfile',
            resolve: {
                activeEmails,
                profile: () => profile,
            }
        }).result;
    };
}

/** @ngInject */
function activeEmails(UserEmailsService) {
    return UserEmailsService.getActiveEmails().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/edit/edit.modal.js